import { useEffect, useRef } from 'react';
import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  label: 'უპირატესობები',
  heading: 'რატომ\nPhoenix?',
  reasons: [
    { num: '01', title: '25+ წლის გამოცდილება', desc: '1999 წლიდან ვემსახურებით საქართველოს ბაზარს.' },
    { num: '02', title: 'ოფიციალური დისტრიბუტორი', desc: 'ვართ Laminam, Ardex, Tecnopol, Fodbo-ს ოფიციალური დისტრიბუტორი.' },
    { num: '03', title: 'ექსპერტული კონსულტაცია', desc: 'ჩვენი სპეციალისტები დაგეხმარებიან სწორი მასალების შერჩევაში.' },
    { num: '04', title: 'ხარისხის გარანტია', desc: 'ყველა პროდუქტი მოდის ოფიციალური მწარმოებლის გარანტიით.' },
  ],
};

export default function WhyUsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const d = useCMS('why_us', DEFAULT);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('animate-fade-up'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-8 md:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
          <div className="lg:col-span-4 reveal opacity-0 lg:sticky lg:top-28">
            <span className="text-[10px] font-bold tracking-[0.35em] uppercase text-[#ec3145] block mb-4">{d.label}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1C1C1C] leading-tight" style={{ whiteSpace: 'pre-line' }}>{d.heading}</h2>
            <div className="w-12 h-px bg-[#ec3145] mt-8"></div>
          </div>
          <div className="lg:col-span-8 flex flex-col">
            {(d.reasons || []).map((r: any, i: number) => (
              <div key={i} className="reveal opacity-0 group flex gap-8 py-10 border-b border-[#1C1C1C]/8 last:border-b-0" style={{ animationDelay: `${i * 0.1}s` }}>
                <span className="font-serif text-xs text-[#1C1C1C]/15 pt-1 flex-shrink-0 w-6">{r.num}</span>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-3 group-hover:text-[#ec3145] transition-colors duration-300">{r.title}</h3>
                  <p className="text-[#1C1C1C]/50 text-sm leading-relaxed">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
